var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-card box-grid"},[_c('div',{staticClass:"box-flex"},[_c('div',{staticClass:"box-image"},[_vm._t("image")],2),_c('div',{staticClass:"box-caption"},[_vm._t("body")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }